import React, { useState } from "react";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Card, Form, Button, ProgressBar, Alert } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";

const UploadArticle = () => {

    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState("");
    const [artikelnummer, setArtikelnummer] = useState("");
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState({ type: "", text: "" });

    const onFileChange = (e) => {
        const f = e.target.files?.[0];
        setMessage({ type: "", text: "" });
        setProgress(0);
    
        if (!f) {
          setFile(null);
          setPreview("");
          return;
        }
        // nur Bilder erlauben (Client-Seite) – Server prüft ebenfalls!
        if (!f.type || !f.type.startsWith("image/")) {
          setMessage({ type: "danger", text: "Bitte wähle eine Bilddatei aus." });
          e.target.value = "";
          setFile(null);
          setPreview("");
          return;
        }
        setFile(f);
        setPreview(URL.createObjectURL(f));
      };
    
      const onSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: "", text: "" });
    
        if (!artikelnummer.trim()) {
          setMessage({ type: "danger", text: "Bitte Artikelnummer eingeben." });
          return;
        }
        if (!file) {
          setMessage({ type: "danger", text: "Bitte ein Bild auswählen." });
          return;
        }
    
        try {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("artikelnummer", artikelnummer.trim());
    
          setUploading(true);
          setProgress(0);
    
          const res = await axios.post("https://dhworld.dietenmeier-harsch.de/uploadArticle.php", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (evt) => {
              if (evt.total) {
                setProgress(Math.round((evt.loaded * 100) / evt.total));
              }
            },
          });
    
          if (res.data?.success) {
            setMessage({ type: "success", text: `Upload erfolgreich: ${res.data.filename}` });
            setFile(null);
            setPreview("");
            setArtikelnummer("");
            setProgress(100);
          } else {
            throw new Error(res.data?.error || "Unbekannter Fehler");
          }
        } catch (err) {
          setMessage({ type: "danger", text: `Fehler beim Upload: ${err.message}` });
        } finally {
          setUploading(false);
        }
      };

  return (
    <Container className="py-5">
           <div className="row pt-4">
        <div className='col-12'>
          <Link to="/insight">
            <i style={{ fontSize: '25px' }} className="bi bi-arrow-return-left"></i>
          </Link>
          <br /><br />
        </div>
      </div>
    <Row className="justify-content-center">
      <Col md={8} lg={6}>
        <Card className="shadow-lg border-0 rounded-4">
          <Card.Body className="p-4">
            <h3 className="mb-3">Bild hochladen</h3>
            <p className="text-muted">Wähle ein Bild und gib eine Artikelnummer ein. Beim Upload wird ein eindeutiger Dateiname erzeugt.</p>

            {message.text ? (
              <Alert variant={message.type} onClose={() => setMessage({ type: "", text: "" })} dismissible>
                {message.text}
              </Alert>
            ) : null}

            <Form onSubmit={onSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Artikelnummer</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="z. B. ART-12345"
                  value={artikelnummer}
                  onChange={(e) => setArtikelnummer(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Bilddatei</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={onFileChange}
                />
                <Form.Text className="text-muted">
                  Erlaubt sind nur Bildformate (jpg, jpeg, png, webp, gif).
                </Form.Text>
              </Form.Group>

              {preview ? (
                <div className="mb-3">
                  <img
                    src={preview}
                    alt="Vorschau"
                    style={{ maxWidth: "100%", borderRadius: "12px" }}
                  />
                </div>
              ) : null}

              {uploading && (
                <div className="mb-3">
                  <ProgressBar now={progress} label={`${progress}%`} animated />
                </div>
              )}

              <div className="d-grid">
                <Button type="submit" size="lg" disabled={uploading}>
                  {uploading ? "Lädt hoch…" : "Hochladen"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>
  )
}

export default UploadArticle